import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import constants from '../../../lib/constants'
import { BeatLoader } from 'react-spinners'
import { getAverageWBC } from 'store/qc'
import { Link } from 'react-router'

class ResultsView extends React.Component {
  static propTypes = {
    qcResults: PropTypes.shape({
      low_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      })),
      normal_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      })),
      high_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      }))
    }),
    level: PropTypes.oneOf(['low', 'normal', 'high']),
    controlMaterial: PropTypes.shape({
      low: PropTypes.shape({
        wbc_min: PropTypes.number,
        wbc_max: PropTypes.number,
        neutrophils_min: PropTypes.number,
        neutrophils_max: PropTypes.number
      }),
      normal: PropTypes.shape({
        wbc_min: PropTypes.number,
        wbc_max: PropTypes.number,
        neutrophils_min: PropTypes.number,
        neutrophils_max: PropTypes.number
      }),
      high: PropTypes.shape({
        wbc_min: PropTypes.number,
        wbc_max: PropTypes.number,
        neutrophils_min: PropTypes.number,
        neutrophils_max: PropTypes.number
      }),
      flowTimes: PropTypes.shape({})
    }),
    flowTimes: PropTypes.shape({}),
    runIndividualQc: PropTypes.func,
    deleteQcJob: PropTypes.func,
    cancelQcJob: PropTypes.func,
    setFlowTime: PropTypes.func,
    allowRunAgain: PropTypes.bool,
    markRunAgain: PropTypes.func
  }

  static defaultProps = {
    qcResults: {
      low_jobs: [],
      normal_jobs: [],
      high_jobs: [],
      flow_times: {}
    },
    level: 'low',
    controlMaterial: {
      low: {
        wbc_min: 2,
        wbc_max: 4,
        neutrophils_min: 20,
        neutrophils_max: 80
      },
      normal: {
        wbc_min: 2,
        wbc_max: 4,
        neutrophils_min: 20,
        neutrophils_max: 80
      },
      high: {
        wbc_min: 2,
        wbc_max: 4,
        neutrophils_min: 20,
        neutrophils_max: 80
      }
    },
    flowTimes: {},
    runIndividualQc: _.noop,
    deleteQcJob: _.noop,
    cancelQcJob: _.noop,
    setFlowTime: _.noop,
    markRunAgain: _.noop,
    allowRunAgain: true
  }

  constructor (ownProps) {
    super(ownProps)
    this.state = {}
  }

  rerunQc = (qcId, level, job) => {
    const { runIndividualQc, deleteQcJob, markRunAgain } = this.props
    markRunAgain()
    let deletePromise = null
    if (job && job.job_id) {
      deletePromise = deleteQcJob(qcId, job)
    } else {
      deletePromise = Promise.resolve()
    }
    deletePromise
    .then(() => {
      runIndividualQc(qcId, level)
    })
  }

  runQc = (qcId, level) => {
    const { runIndividualQc } = this.props
    runIndividualQc(qcId, level)
  }

  getMaxBiasJob = () => {
    const { qcResults, level } = this.props
    const mean = getAverageWBC(qcResults[`${level}_jobs`])
    let maxBias = 0
    let maxBiasJob = null
    _.forEach(qcResults[`${level}_jobs`], (job) => {
      if (job && job.wbc_count) {
        const bias = Math.abs(mean - job.wbc_count)
        if (bias > maxBias) {
          maxBias = bias
          maxBiasJob = job
        }
      }
    })
    return maxBiasJob
  }

  getJobActions = (job, maxBiasJob) => {
    const { qcResults, allowRunAgain, level, cancelQcJob } = this.props
    if (job.job_id) {
      if (job.wbc_count) {
        return (
          ((allowRunAgain && maxBiasJob === job) ? (
            <button className='btn btn-secondary' onClick={() => this.rerunQc(qcResults.id, level, job)}>
              Run Again
            </button>
            ) : null
        ))
      } else if (job.job_status === 'uploading' || job.job_status === 'imaging') {
        return (
          <button className='btn btn-secondary' onClick={() => cancelQcJob(qcResults.id, job)}>
            Cancel
          </button>
        )
      } else if (job.job_status === constants.JOB_STATUSES.CANCELLED || job.error_message !== null) {
        return (
          <button className='btn btn-secondary' onClick={() => this.rerunQc(qcResults.id, level, job)}>
            Run Again
          </button>
        )
      }
    } else {
      return (
        <button className='btn btn-secondary' onClick={() => this.runQc(qcResults.id, level)}>
          Run
        </button>
      )
    }
  }


  render () {
    const { qcResults, controlMaterial, flowTimes, level, setFlowTime } = this.props
    const maxBiasJob = this.getMaxBiasJob()
    return (
      <div style={{ paddingTop: 20 }}>
        <h5>Level: {_.upperFirst(level)}</h5>
        <table className='table table-bordered avoid'>
          <thead className='thead-light'>
            <tr>
              <th scope='col'>Replicate</th>
              <th scope='col'>Flow Time</th>
              <th scope='col'>Job ID</th>
              <th scope='col'>Actions</th>
              <th scope='col'>Status</th>
              <th scope='col'>WBC Value</th>
              <th scope='col'>Neut% Value</th>
              <th scope='col'>WBC Range</th>
              <th scope='col'>Neut% Range</th>
              <th scope='col'>WBC In Range</th>
              <th scope='col'>Neut% In Range</th>
            </tr>
          </thead>
          <tbody>
            {
              _.map([0, 1, 2], (index) => {
                const job = qcResults[`${level}_jobs`][index] || {}
                let flowTime = undefined
                if (!_.isEmpty(job)) {
                  flowTime = flowTimes[job.job_id]
                }
                const wbcPassed = job.wbc_count > controlMaterial[level].wbc_min && job.wbc_count < controlMaterial[level].wbc_max
                const neutPassed = job.neutrophils > controlMaterial[level].neutrophils_min && job.neutrophils < controlMaterial[level].neutrophils_max
                const debouncedSetFlowTime = _.debounce(setFlowTime, 1000)
                return (
                  <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td>
                      <input value={flowTime} disabled={!job.job_id} onChange={(e) => debouncedSetFlowTime(job.job_id, e.target.value)} placeholder='Seconds' />
                    </td>
                    <td>{job ? <Link to={`/jobs/${job.job_id}/images`}>{job.job_id}</Link> : 'No Job'}</td>
                    <td>
                      { this.getJobActions(job, maxBiasJob) }
                    </td>
                    <td>
                    <div>
                        {job.job_status}
                      </div>
                      {
                        _.isEmpty(job) || constants.FINISHED_JOB_STATUSES.indexOf(job.job_status) > -1 ? null : (
                          <div>
                            <BeatLoader loading color={'#6f8eaa'} />
                          </div>
                        )
                      }
                    </td>
                    <td>{job.wbc_count}</td>
                    <td>{job.neutrophils}</td>
                    <td>{controlMaterial[level].wbc_min} - {controlMaterial[level].wbc_max}</td>
                    <td>{controlMaterial[level].neutrophils_min} - {controlMaterial[level].neutrophils_max}</td>
                    <td>{wbcPassed ? 'Yes' : 'No'}</td>
                    <td>{neutPassed ? 'Yes' : 'No'}</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    )
  }
}

export default ResultsView



// WEBPACK FOOTER //
// ./src/routes/QC/components/ResultsView.jsx